/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Filter_No_OverridesInputs */



/**
* | output |
* | --- |
* | "No overrides configured yet." |
*
* @param {Rights_Filter_No_OverridesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_filter_no_overrides = /** @type {((inputs?: Rights_Filter_No_OverridesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Filter_No_OverridesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Überschreibungen konfiguriert.")
	return /** @type {LocalizedString} */ ("No overrides configured yet.")
});